module.exports = __webpack_public_path__ + "img/CONSTRUCT.ae6964aa.svg";